<template>
  <v-data-table                                    
                    :headers="headers"
                    :options.sync="pagingOptions"
                    :server-items-length="totalItemCount"
                    :items="gridData"
                    item-key="adpointid"                                  
                    class="table-one"
                    multi-sort
                    :footer-props="{
                        'items-per-page-options': [5, 10, 20, 50]
                    }"
                >             
                    <template v-slot:[`header.data-table-select`]></template>    
                    <template v-slot:item.deviceId="{item}">
                        <div class="d-flex align-center">                            
                            <p class="ma-0 font-weight-medium">
                                {{ getDeviceName(item.deviceId) }}
                            </p>
                        </div>
                    </template>   
                    <template v-slot:[`header.data-table-select`]></template>    
                    <template v-slot:item.networkId="{item}">
                        <div class="d-flex align-center">                            
                            <p class="ma-0 font-weight-medium">
                                {{ getNetworkName(item.networkId) }}
                            </p>
                        </div>
                    </template>  
                    <template v-slot:item.fullname="{item}">
                        <div class="d-flex align-center">
                            <v-avatar class="mr-2" size="26" dark>
                                <img src="@/assets/images/avatars/001-man.svg" alt="" />
                            </v-avatar>
                            <p class="ma-0 font-weight-medium">
                                {{ item.fullname }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:item.aud_create_date="{item}">
                        <div class="d-flex align-center">                        
                            <p class="ma-0 font-weight-medium">
                                {{ item.aud_create_date | formatDate }}
                            </p>
                        </div>
                    </template>
                    

                    <template v-slot:item.action="{item}">
                        <div class="d-flex">
                            <!--<v-tooltip top>
                                <template v-slot:activator="{on, attrs}">
                                    <v-btn
                                        color="blue"
                                        dark
                                        v-bind="attrs"
                                        v-on="on"
                                        icon
                                        :to="'/mng/adpoints/management/view/' + item.id"
                                    >
                                        <v-icon>mdi-file-eye</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Details</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{on, attrs}">
                                    <v-btn                                        
                                        dark
                                        v-bind="attrs"
                                        v-on="on"
                                        icon
                                        :to="'/mng/adpoints/management/edit/' + item.id"
                                    >
                                        <v-icon>mdi-pencil-box-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Edit</span>
                            </v-tooltip>
                            
                            <v-tooltip top>
                                <template v-slot:activator="{on, attrs}">
                                    <v-btn                                        
                                        dark
                                        v-bind="attrs"
                                        v-on="on"
                                        icon
                                    >
                                        <v-icon>mdi-trash-can-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Delete</span>
                            </v-tooltip>
                            <v-tooltip top v-if="selectedNetworkIsWeb">
                                <template v-slot:activator="{on, attrs}">
                                    <v-btn
                                        @click="copyWebCodeSnippet(item.adpointid)"
                                        color="orange"
                                        dark
                                        v-bind="attrs"
                                        v-on="on"
                                        icon                                        
                                    >
                                        <v-icon>mdi-code-braces-box</v-icon>
                                    </v-btn>
                                </template>
                                <span>Copy Web Placement Code Snippet</span>
                            </v-tooltip>
                            <v-tooltip top v-if="!selectedNetworkIsWeb">
                                <template v-slot:activator="{on, attrs}">
                                    <v-btn
                                        @click="copyWebDeviceClientUrl(item.adpointid)"
                                        color="orange"
                                        dark
                                        v-bind="attrs"
                                        v-on="on"
                                        icon                                        
                                    >
                                        <v-icon>mdi-web</v-icon>
                                    </v-btn>
                                </template>
                                <span>Copy Device Client Adpoint Url</span>
                            </v-tooltip>-->
                        </div>
                    </template>
                </v-data-table>
</template>

<script>
import {api} from "src/api/index";

export default {
    name: "AdpointsGridComponent",
    components: {},
    props: {
        cluster: Number
    },
    data() {
        return {
            pagingOptions: {},
            quicksearch: null,
            totalItemCount: 0,
            networkOptions: [],
            deviceTypeOptions: [],
            locationOptions: [],
            baseData: [],            

            headers: [
                {text: 'Adpoint ID', align: 'start', value: 'adpointid',  sortable: false},                
                {text: 'Description', align: 'start', value: 'description',  sortable: false},  
                {text: 'Placement Type', value: 'deviceId',  sortable: false},
                {text: 'Network', align: 'start', value: 'networkId',  sortable: false},                
                // {text: 'Capacity', value: 'nominalCapacity'},
                // {text: '', value: 'usedCapacity'},
                // {text: 'Products', value: 'fat'},
                // {text: 'Wallet Balance', value: 'carbs'},

                // {text: 'Status', value: 'status',  sortable: false},

                // {text: 'Create Date', value: 'aud_create_date'},                
                // {text: 'Last Update', value: 'aud_update_date'},
                {text: '', value: 'action'}                
            ],

        };
    },
    computed: {
        gridData() {
            const rspData = this.baseData;
            return this.formatListData(rspData);
        },
    },
    watch: {
        pagingOptions: {
        handler () {
            this.fetchGridData();            
        },
        deep: true,
      },
    },
    methods: {
        formatListData(rspData) {
            const d = rspData.map(d => { 
                return {
                    ...d, 
                    //fullname: d.firstName + ' ' + d.lastName,                    
                } })
            return d;
        },
        getDeviceName(deviceId) {
            let tgtNet = this.deviceTypeOptions.find(n=>n.value === deviceId)
            if(tgtNet) {
                return tgtNet.text;
            }
            return deviceId;
        },
        getNetworkName(networkId) {
            let tgtNet = this.networkOptions.find(n=>n.value === networkId)
            if(tgtNet) {
                return tgtNet.text;
            }
            return networkId;
        },
        async fetchGridData() { 
            let qstr = "";
            //paging
            console.log("\nPAGING PAGING PAGING PAGING \n" + JSON.stringify(this.pagingOptions));
            const { sortBy, sortDesc, page, itemsPerPage } = this.pagingOptions;
            const limit = itemsPerPage;
            const currentPage = page;
            qstr += "?currentPage=" + page + "&limit=" + limit;
            //sorting       
            //if(!qstr.includes("?")) qstr = "?" + qstr;
            for(let i=0; i<sortBy.length; i++) {                
                qstr += "&sortBy[" + i + "]=" + sortBy[i];                
            }
            //sorting                   
            for(let i=0; i<sortDesc.length; i++) {                
                qstr += "&sortDesc[" + i + "]=" + sortDesc[i];                
            }     
            //criteria - selected network & duration
            qstr += "&clusterId=" + this.cluster;
            //qstr += "&calcInterval=" + this.selectedCalcInterval;
            //criteria - advanced filters
            // //if(!qstr.includes("?")) qstr = "?" + qstr;
            // if(this.$refs.advancedfilter.qs) {                
            //     qstr += this.$refs.advancedfilter.qs;
            // }
            //quicksearch
            if(this.quicksearch && this.quicksearch.length > 0){
                //if(!qstr.includes("?")) qstr = "?" + qstr;
                qstr += "&quicksearch=" + encodeURIComponent(this.quicksearch);
            }      
            //alert(querystr);
            const rsp = await api.adpoint.getList(qstr);
            this.baseData = rsp.data.data.map(d => { return {...d, 
                                                        //fullname: d.firstName + ' ' + d.lastName
                                                    } }); 
            this.totalItemCount = rsp.data.total;
            this.$emit("setTotal", this.totalItemCount);
        }
    },
    async created() {
        const rsp = await api.adpoint.getInitData();
        this.networkOptions = rsp.data.networkOptions;
        this.deviceTypeOptions = rsp.data.deviceTypeOptions;
        this.locationOptions = rsp.data.locationOptions;
    },
    async mounted() {
        //await this.fetchGridData();
    },
}
</script>


<style>

</style>